/* Xtrait, horizontal product carousels (scroll-snap + arrows + lazy recs fetch) */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.xPcInit === '1') return;
    root.dataset.xPcInit = '1';

    var row = root.querySelector('[data-x-pcarousel-row]');
    var viewport = root.querySelector('.x-pcarousel__viewport') || (row && row.parentElement);
    var prev = root.querySelector('[data-x-pcarousel-prev]');
    var next = root.querySelector('[data-x-pcarousel-next]');
    if (!row) return;

    var hoverFrame = null;
    var hoverSpeed = 0;
    var hoverActive = false;
    var pointerDown = null;
    var suppressClickUntil = 0;
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');

    function cardStep() {
      var card = row.querySelector('.x-pcarousel__card');
      if (!card) return row.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var max = row.scrollWidth - row.clientWidth - 1;
      var atStart = row.scrollLeft <= 1;
      var atEnd = row.scrollLeft >= max;
      var fits = row.scrollWidth <= row.clientWidth + 2;
      if (prev) prev.classList.toggle('is-hidden', atStart || fits);
      if (next) next.classList.toggle('is-hidden', atEnd || fits);
    }

    function canScroll() {
      return row.scrollWidth > row.clientWidth + 2;
    }

    function snapToNearestCard(behavior) {
      if (!canScroll()) return;
      var step = cardStep();
      if (!step) return;
      var max = Math.max(0, row.scrollWidth - row.clientWidth);
      var target = Math.min(max, Math.max(0, Math.round(row.scrollLeft / step) * step));
      if (Math.abs(target - row.scrollLeft) > 1) {
        row.scrollTo({ left: target, behavior: behavior || 'smooth' });
      }
    }

    function stopHoverScroll(snap) {
      var shouldSnap = snap && (hoverActive || row.classList.contains('is-edge-scrolling'));
      hoverActive = false;
      hoverSpeed = 0;
      root.classList.remove('is-hovering-left', 'is-hovering-right');
      row.classList.remove('is-edge-scrolling');
      row.style.removeProperty('scroll-snap-type');
      row.style.removeProperty('scroll-behavior');
      if (hoverFrame) {
        window.cancelAnimationFrame(hoverFrame);
        hoverFrame = null;
      }
      if (shouldSnap) snapToNearestCard('smooth');
    }

    function hoverTick() {
      if (!hoverActive || !hoverSpeed) {
        stopHoverScroll();
        return;
      }

      var max = row.scrollWidth - row.clientWidth;
      if ((hoverSpeed < 0 && row.scrollLeft <= 0) || (hoverSpeed > 0 && row.scrollLeft >= max - 1)) {
        updateArrows();
        stopHoverScroll();
        return;
      }

      row.scrollBy({ left: hoverSpeed, behavior: 'auto' });
      updateArrows();
      hoverFrame = window.requestAnimationFrame(hoverTick);
    }

    function setHoverSpeedFromPointer(e) {
      var isFineMouse = !e.pointerType || e.pointerType === 'mouse' || (finePointer && finePointer.matches);
      if (!viewport || !isFineMouse || pointerDown || !canScroll()) {
        stopHoverScroll();
        return;
      }

      var rect = viewport.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var edge = Math.min(220, Math.max(86, rect.width * 0.22));
      var maxSpeed = Math.min(18, Math.max(9, row.clientWidth / 72));
      var nextSpeed = 0;

      if (x < edge) {
        nextSpeed = -maxSpeed * Math.pow((edge - x) / edge, 1.35);
      } else if (x > rect.width - edge) {
        nextSpeed = maxSpeed * Math.pow((x - (rect.width - edge)) / edge, 1.35);
      }

      if (Math.abs(nextSpeed) < 0.45) {
        stopHoverScroll(true);
        return;
      }

      hoverSpeed = nextSpeed;
      hoverActive = true;
      row.classList.add('is-edge-scrolling');
      row.style.scrollSnapType = 'none';
      row.style.scrollBehavior = 'auto';
      root.classList.toggle('is-hovering-left', hoverSpeed < 0);
      root.classList.toggle('is-hovering-right', hoverSpeed > 0);
      if (!hoverFrame) hoverFrame = window.requestAnimationFrame(hoverTick);
    }

    function onPointerDown(e) {
      if (!canScroll() || e.button && e.button !== 0) return;
      pointerDown = {
        id: e.pointerId,
        type: e.pointerType || 'mouse',
        x: e.clientX,
        y: e.clientY,
        scrollLeft: row.scrollLeft,
        dragged: false,
        captured: false
      };
      stopHoverScroll();
    }

    function onPointerMove(e) {
      if (!pointerDown || e.pointerId !== pointerDown.id) return;
      var dx = e.clientX - pointerDown.x;
      var dy = e.clientY - pointerDown.y;
      if (!pointerDown.dragged && Math.hypot(dx, dy) > 8) {
        pointerDown.dragged = true;
        row.classList.add('is-dragging');
        if (pointerDown.type === 'mouse' && row.setPointerCapture) {
          row.setPointerCapture(e.pointerId);
          pointerDown.captured = true;
        }
      }
      if (!pointerDown.dragged) return;

      suppressClickUntil = Date.now() + 450;
      if (pointerDown.type === 'mouse') {
        e.preventDefault();
        row.scrollLeft = pointerDown.scrollLeft - dx;
        updateArrows();
      }
    }

    function onPointerUp(e) {
      if (!pointerDown || e.pointerId !== pointerDown.id) return;
      if (pointerDown.dragged) suppressClickUntil = Date.now() + 450;
      if (pointerDown.captured && row.hasPointerCapture && row.hasPointerCapture(e.pointerId)) {
        row.releasePointerCapture(e.pointerId);
      }
      pointerDown = null;
      row.classList.remove('is-dragging');
      if ((e.pointerType || 'mouse') === 'mouse') snapToNearestCard('smooth');
    }

    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left:  cardStep(), behavior: 'smooth' }); });

    row.addEventListener('scroll', updateArrows, { passive: true });
    row.addEventListener('pointerdown', onPointerDown);
    row.addEventListener('pointermove', onPointerMove);
    row.addEventListener('pointerup', onPointerUp);
    row.addEventListener('pointercancel', onPointerUp);
    row.addEventListener('click', function (e) {
      if (Date.now() < suppressClickUntil) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
    }, true);
    if (viewport) {
      viewport.addEventListener('pointermove', setHoverSpeedFromPointer, { passive: true });
      viewport.addEventListener('pointerleave', function () { stopHoverScroll(true); });
      viewport.addEventListener('blur', function () { stopHoverScroll(true); }, true);
    }
    window.addEventListener('resize', updateArrows);
    requestAnimationFrame(updateArrows);
  }

  function initAll(scope) {
    var carousels = (scope || document).querySelectorAll('[data-x-pcarousel]');
    for (var i = 0; i < carousels.length; i++) initCarousel(carousels[i]);
  }

  function fetchRecs(container) {
    if (container.dataset.xRecsLoaded === '1') return;
    container.dataset.xRecsLoaded = '1';
    var url = container.getAttribute('data-url');
    if (!url) return;
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim()) { container.style.display = 'none'; return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var rendered = tmp.querySelector('[data-x-pcarousel]');
        if (!rendered) { container.style.display = 'none'; return; }
        container.appendChild(rendered);
        container.classList.add('is-loaded');
        initCarousel(rendered);
      })
      .catch(function () { container.style.display = 'none'; });
  }

  function observeRecs() {
    var nodes = document.querySelectorAll('[data-x-recs]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(fetchRecs);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { fetchRecs(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '300px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); observeRecs(); });
  } else {
    initAll();
    observeRecs();
  }
})();
